export default {"src":"/_next/static/media/historyBg.0443a1cf.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};